interface PointsProgressProps {
  totalPoints: number;
  maxPoints: number;
  label: string;
}

export default function PointsProgress({ totalPoints, maxPoints, label }: PointsProgressProps) {
  const maximum = Math.max(1, maxPoints);
  const value = Math.min(maximum, Math.max(0, totalPoints));

  return (
    <progress
      aria-label={label}
      value={value}
      max={maximum}
      className="h-[18px] w-full appearance-none overflow-hidden rounded-full border-0 bg-quanta-progress-track [&::-webkit-progress-bar]:bg-quanta-progress-track [&::-webkit-progress-value]:bg-quanta-progress [&::-moz-progress-bar]:bg-quanta-progress"
    />
  );
}
